<template>
    <div class="c-browserwarning">
        <div class="c-browserwarning__inner">
            <div class="c-browserwarning__content">We kunnen deze puzzel helaas niet tonen wanneer omdat uw browser verouderd is. Gelieve uw browser te updaten om de puzzel werkende te krijgen.</div>
        </div>
    </div>
</template>

<script>

export default {
  name: 'Browserwarning',
}

</script>
